import {
  queryAddEditNotification,
  queryAddNewNotification,
  queryDeleteItem,
  queryEditItemNotification,
  queryList,
} from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const initialState = {
  newNotification: false,
  selectedItem: null,
  formConfig: null,
  list: [],
  pagination: meta,
  select: 'id,emails,status',
  notSelectSearch: 'status,users',
  expand: {
    form: { select: 'name' },
    field: { select: 'displayText' },
    users: { expand: { user: { select: 'fullName' } } },
  },
  paramsEdit: {
    select: 'id,emails,status,isSendToApplicantEnabled',
    expand: {
      users: { expand: { user: { select: 'fullName' } } },
    },
  },
  view: false,
  orderBy: '',
  id: null,
  loadingItem: false,
};

const Model = {
  namespace: 'actionNotification',

  state: initialState,

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'queryNotifications',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewNotification({ payload }, { put }) {
      yield put({
        type: 'addNotification',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewNotification',
          payload,
        });
      }
    },

    *editItemNotification({ payload }, { call, put }) {
      try {
        const table = yield call(queryEditItemNotification, payload);
        yield put({
          type: 'editNotification',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewNotification({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddNewNotification, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveNotification',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditNotification({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddEditNotification, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveNotification',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(queryDeleteItem, id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveNotification',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *showItemNotification({ view }, { put }) {
      yield put({
        type: 'showEditItemNotification',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryNotifications(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addNotification(state, { payload }) {
      return {
        ...state,
        newNotification: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewNotification(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editNotification(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    saveNotification(state, { payload }) {
      return {
        ...state,
        saveNotification: payload,
        newNotification: false,
        selectedItem: false,
      };
    },

    showEditItemNotification(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newNotification: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
      };
    },

    clearState() {
      return initialState;
    },
  },
};

export default Model;
